(ns ycweb.util.date
  (:require
   #?@(:clj
       [[clj-time.coerce :as tc]
        [clj-time.core :as dt]
        [clj-time.format :as dtfmt]
        [clj-time.local :as tl]
        [clj-time.predicates :as tp]
        [cheshire.generate :as jsongenerate]
        [cheshire.factory :as jsonfactory]
        [util.core :as uc]]
       :cljs
       [[cljs-time.coerce :as tc]
        [cljs-time.core :as dt]
        [cljs-time.format :as dtfmt]
        [cljs-time.local :as tl]
        [cljs-time.predicates :as tp]])
   [util.string :as str]
   [ycweb.util.core :as u])
  #?(:clj
     (:import
      (java.lang Math)
      (org.joda.time DateTimeZone DateTime DateTimeFieldType)
      (org.joda.time.format DateTimeFormatter)
      (java.util SimpleTimeZone Date)
      (java.text SimpleDateFormat)
      (com.fasterxml.jackson.core.json WriterBasedJsonGenerator))))

;; Setup various environment bits for clojure + jodatime
#?(:clj
   (jsongenerate/add-encoder
     DateTime
     (fn [c ^WriterBasedJsonGenerator jsonGenerator]
       (let [sdf (SimpleDateFormat. jsonfactory/default-date-format)]
         (.setTimeZone sdf (SimpleTimeZone. 0 "UTC"))
         (.writeString jsonGenerator (.format sdf (tc/to-date c)))))))

(defn write-date "Write date to JSON api format"
  [dt]
  #?(:cljs
     (tc/to-string dt)

     :clj
     (tc/to-string dt)))

#?(:clj
   (defmethod print-dup DateTime
     [o writer]
     (.write writer (format "#inst \"%s\"" o))))

#?(:clj
   (defmethod print-method DateTime
     [o writer]
     (.write writer (format "#inst \"%s\"" o))))

(def minute 60000)

(def hour (* 60 minute))

(def date-formatter (dtfmt/formatter "yyyy-MM-dd HH:mm:ss"))

(defn parse-date-formats
  "Parse a string into a date using the first valid format of the supplied formats.
   See java.text.SimpleDateFormat for formats."
  [str & formats]
  (let [s
        (map
          (fn [format]
            (try
              (dtfmt/parse (dtfmt/formatter format) str)
              (catch #?@(:cljs [js/Error _] :clj [Exception _]))))
          formats)]
    (first (remove nil? s))))

(defn same-day? [dt-a dt-b]
  (cond
    (nil? dt-a) (nil? dt-b)
    (nil? dt-b) false
    :else
    (and
      (= (dt/year dt-a) (dt/year dt-b))
      (= (dt/month dt-a) (dt/month dt-b))
      (= (dt/day dt-a) (dt/day dt-b)))))

(defn interval [dt-a dt-b]
  (cond
    (nil? dt-a) (dt/interval (dt/now) (dt/now))
    (nil? dt-b) (dt/interval (dt/now) (dt/now))
    :else
    (if (dt/before? dt-b dt-a)
      (dt/interval dt-b dt-a)
      (dt/interval dt-a dt-b))))

;; TODO: Implement parse-date in cljs? or just remove it entirely.
#?(:clj
   (defmulti parse-date class)
   :cljs
   (defn parse-date [date]
     (parse-date-formats (str date) "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'" "yyyy-MM-dd'T'HH:mm:ss'Z'" "yyyy-MM-dd'T'HH:mm:ssZ" "yyyy-MM-dd HH:mm:ss" "yyyy-MM-dd" "dd-MM-yyyy" "yyyy/MM/dd" "yy/MM/dd" "MM/dd/YYYY" "EEE MMM dd HH:mm:ss zzz yyyy")))

;; Anything smaller than this number is probably a unix epoch (seconds since 1970)
;; Anything larger is likely a milliseconds since 1970.
(def epoch-millis-edge (Math/pow 10 10))

#?(:clj
   (defmethod parse-date Long [date]
     (if (< date epoch-millis-edge)
       (tc/from-long (* date 1000))
       (tc/from-long date))))

#?(:clj
   (defmethod parse-date Integer [date]
     (when-not (zero? date)
       (parse-date (long date)))))

;; This invariant needs to hold at all times, so compile fail if this is wrong.
#?(:clj
   (let [nowepoch (int (/ (.getTime (Date.)) 1000))]
     (assert (= (parse-date nowepoch) (parse-date (* nowepoch 1000))))))

#?(:clj
   (defmethod parse-date String [date]
     (parse-date-formats (str date) "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'" "yyyy-MM-dd'T'HH:mm:ss'Z'" "yyyy-MM-dd'T'HH:mm:ss" "yyyy-MM-dd'T'HH:mm:ssZ" "yyyy-MM-dd HH:mm:ss" "yyyy-MM-dd" "dd-MM-yyyy" "yyyy/MM/dd" "yy/MM/dd" "MM/dd/YYYY" "EEE MMM dd HH:mm:ss zzz yyyy")))

#?(:clj
   (defmethod parse-date :default [date]
     (tc/to-date-time date)))


(defn from-millis [millis]
  (tc/to-date-time millis))


(defn sqltime [dt]
  #?(:clj (tc/to-sql-time dt)
     :cljs (tc/to-date dt)))

(defn date-format [dt & [fmt]]
  #?(:clj
     (if (nil? dt)
       ""
       (dtfmt/unparse (dtfmt/formatter (or fmt "dd MMM HH:mm")) (parse-date dt)))
     :cljs
     (if (nil? dt)
       ""
       (dtfmt/unparse (dtfmt/formatter (or fmt "dd MMM HH:mm")) (tc/to-local-date dt)))))


(def one-day (* 24 60 60 1000))


(defn ^:deprecated now
  "Current date - broken, don't use. use utc-now. here be dragons. you have been warned. KITTENS WILL DIE! THINK of TEH Kittehns
   Use dt/now instead for direct UTC timestamp."
  []
  #?(:clj (.withZoneRetainFields ^DateTime (tl/local-now) (DateTimeZone/UTC))
     :cljs (dt/now)))

(defn age [dt]
  #?(:clj
     (- (.getMillis (dt/now))
       (.getMillis (tc/to-date-time dt)))

     :cljs
     (ex-info "Function Not Implemented" "age doesn't exist for cljs yet.")))

(defn php-age
  "How many seconds old?"
  [unixtime]
  (/ (age (* (or unixtime 0) 1000)) 1000))

(defn age-string [dt]
  #?(:clj
     (if (nil? dt)
       ""
       (let [m (Math/abs (long (/ (age dt) 60000)))]
         (cond
           (< m 60) (format "00 hrs %02d min" (long m))
           (< m (* 48 60)) (format "%02d hrs" (long (/ m 60)))
           :else (format "%02d days" (long (/ m (* 24 60)))))))

     :cljs
     (ex-info "Function Not Implemented" "age-string doesn't exist for cljs yet.")))

(def nth-day-periods
  #?(:clj
     {:week (DateTimeFieldType/dayOfWeek)
      :month (DateTimeFieldType/dayOfMonth)
      :year (DateTimeFieldType/dayOfYear)}
     :cljs {}))

(defn nth-day [period n ^DateTime dt]
  #?(:clj
     (do
       (assert (contains? nth-day-periods period))
       (.withMillisOfDay (.withField dt (get nth-day-periods period) n) 0))
     :cljs
     (ex-info "Function Not Implemented" "nth-day doesn't exist for cljs yet.")))


(declare now+2)
(defn ^:deprecated now+2
  "This function is only for interop with php +2 hour timestamp.. Let's fix it"
  []
  #?(:clj
     (.withZoneRetainFields ^DateTime (tl/local-now) (DateTimeZone/forID "+02:00"))
     :cljs (ex-info "Function Not Implemented" "now+2 doesn't exist for cljs yet.")))

#?(:clj
   (defn get-hours-minutes
     "Convert a date that is less than a day ago to be a String of hours and minutes"
     [date]
     (str "at " (dtfmt/unparse (dtfmt/formatters :hour-minute) (parse-date date)) " today")))

#?(:clj
   (defn relative-time-string
     "Return a String description of the current time"
     [date time]
     (cond
       (> time 1) (str time " days ago")
       (= time 1) (str "1 day ago")
       :else (get-hours-minutes date))))

(defmulti older-than (fn [type unit date] type))

(defmethod older-than :minutes [_ unit date]
  (if (nil? date)
    true
    (> (age date) (* unit 60000))))

(defmethod older-than :hours [_ unit date]
  (if (nil? date)
    true
    (> (age date) (* unit 3600000))))

(defmethod older-than :days [_ unit date]
  (if (nil? date)
    true
    (> (age date) (* unit one-day))))

(defmethod older-than :months [_ unit date]
  (dt/before? (tc/to-date-time date) (dt/minus (dt/now) (dt/months unit))))


(defn coerce-date [dt]
  (tc/to-date-time dt))

(defn coerce-phptimestamp-int-fields [fieldks row]
  (->
    (reduce
      (fn [r fk]
        (if-let [v (get r fk)]
          (assoc r
            fk
            (coerce-date (* 1000 v)))
          r))
      row fieldks)))

;; TODO: This should get handled by middleware automatically.
#?(:clj
   (defn coerce-jodatime [row]
     (reduce
       (fn [r [k v]]
         (assoc r k (.toDate v)))
       row
       (->>
         row
         (filter (fn [[k v]] (instance? DateTime v)))))))

(defn format-date
  "Format a UTC into the +0200 local timezone"
  [dt fmt & [dzc]]
  (if (nil? dt)
    ""
    (dtfmt/unparse
      (dtfmt/formatter
        fmt
        #?(:clj
           (DateTimeZone/forID (or dzc "+0200"))
           :cljs nil
           #_(ex-info "Function Not Implemented" "JodaTimezone doesn't exist for cljs yet.")))
      #?(:clj
         (coerce-date dt)
         :cljs
         (cljs-time.local/as-local-date-time-to-time-zone (coerce-date dt))))))

#?(:clj
   (defn format-tidy-date
     [datestring]
     (dtfmt/unparse date-formatter (parse-date datestring))))

#?(:clj
   (defn tidy-date-string
     [dt-string]
     (if-not (str/blank? dt-string)
       (format-tidy-date dt-string)
       "")))

(defn millis [dt]
  #?(:clj
     (.getMillis (tc/to-date-time dt))
     :cljs
     (tc/to-long dt)))

(defn seconds [dt]
  (quot (millis dt) 1000))

(defn php-timestamp
  ([] (php-timestamp (dt/now)))
  ([date]
   (long (/ (millis date) 1000))))

(defn from-php-date
  [epoch-seconds & [utc?]]
  (cond
    (#{nil "" "0" 0} epoch-seconds)
    nil

    (number? epoch-seconds)
    (->>
      (if utc? epoch-seconds (+ (* 2 60 60) epoch-seconds))
      (* 1000)
      (long)
      (tc/to-date-time))

    :else
    (tc/to-date-time epoch-seconds)))

#?(:clj
   (defn ^:deprecated nice-human-time-period
     "Convert the date String to a human readable string"
     [datestring]
     (tidy-date-string (str datestring))))

;; TODO: probably superceded in utils
(defn minutes-ago [^DateTime date]
  #?(:clj
     (when date
       (let [diff (- (.getMillis (now)) (.getMillis date))
             mins (long (/ diff 60000))]
         (cond
           (< mins 60) (str mins "m ago")
           (< mins (* 24 60)) (str (long (/ mins 60)) "h ago")
           :else (str (long (/ mins 60 24)) "d ago"))))
     :cljs (ex-info "Function Not Implemented" "minutes-ago doesn't exist for cljs yet.")))


(defn hours-string [dt]
  (if (nil? dt)
    ""
    (let [m (Math/abs (long (/ (age dt) 60000)))]
      (str/format "%03d hrs" (long (/ m 60))))))

(defn tomorrow []
  (dt/plus (dt/now) (dt/days 1)))

(defn at-midnight [dt]
  #?(:cljs
     (dt/at-midnight dt)
     :clj
     (dt/with-time-at-start-of-day dt)))

(defn ceil
  [date-time]
  (->
    date-time
    (at-midnight)
    (dt/minus (dt/millis 1))
    (dt/plus (dt/days 1))))

(defn google-calendar-public-holidays []
  #?(:clj
     (mapcat
       #(->>
          (map (fn [s] (str/split s #"[:]")) (str/split % #"\r\n"))
          (map (fn [[k v]] [k v]))
          (filter (fn [[k v]] (= k "DTSTART;VALUE=DATE")))
          (map (fn [[_ v]] (coerce-date (parse-date-formats v "yyyyMMdd")))))
       (str/split
         (slurp "https://calendar.google.com/calendar/ical/en.sa%23holiday%40group.v.calendar.google.com/public/basic.ics") #"BEGI"))
     :cljs []))

(def holiday-atom (atom nil))

(defn public-holidays []
  (when
    (or (nil? @holiday-atom) (dt/after? (dt/now) (dt/plus (:updated-at @holiday-atom) (dt/months 6))))
    (reset! holiday-atom
      {:updated-at (dt/now) :dates (google-calendar-public-holidays)}))
  @holiday-atom)

(def direction-fns
  {:forward #'dt/plus
   :backward #'dt/minus})

(defn business-days
  "Takes a date-time and the amount of days to move. Defaulting to forward traversal.

   Additionally it takes an option-map with keys :direction and :saturday-as-business-day:
   - `:direction` one of `:forward`, `:backward`, defaulting to `:forward` if not supplied.
   - `:saturday-as-business-day` boolean, one of `true` or `false`."
  ([start-date days]
   (business-days start-date days {}))
  ([start-date days
    & [{:keys [direction saturday-as-business-day]
        :or {direction :forward
             saturday-as-business-day false}}]]
   (assert
     (#{:forward :backward} direction)
     "Allowed directions: :forward or :backward")

   (let [ref-date (at-midnight start-date)
         end-date (dt/plus ref-date (dt/days days))
         public-holidays
         (->>
           (:dates (public-holidays))
           (filter
             #(and
                (or
                  (dt/equal? % ref-date)
                  (dt/after? % ref-date))
                (or
                  (dt/equal? % end-date)
                  (dt/before? % end-date))))
           (set))
         is-business-day?
         (fn [dt]
           (and
             (not (contains? public-holidays dt))
             (or
               (tp/weekday? dt)
               (when saturday-as-business-day
                 (tp/saturday? dt)))))]
     (loop [date-time ref-date cnt days]
       (cond
         (and
           (not (pos? cnt))
           (is-business-day? date-time))
         date-time

         :else
         (recur
           (->
             direction-fns
             (get direction #'dt/plus)
             (apply [date-time (dt/days 1)]))
           (if
             (is-business-day? date-time)
             (dec cnt)
             cnt)))))))

(defn num-of-business-days
  "Takes a start-date and end-date, determining the amount of business days between the two dates.
   Defaulting to forward traversal.

   Additionally it takes an option-map with keys :direction and :saturday-as-business-day:
   - `:direction` one of `:forward`, `:backward`, defaulting to `:forward` if not supplied.
   - `:saturday-as-business-day` boolean, one of `true` or `false`."
  ([start-date end-date]
   (num-of-business-days start-date end-date {}))
  ([start-date end-date
    & [{:keys [direction saturday-as-business-day holiday-list]
        :or
        {direction :forward
         saturday-as-business-day false
         holiday-list (:dates (public-holidays))}}]]
   (assert
     (#{:forward :backward} direction)
     "Allowed directions: :forward or :backward")

   (let [ref-date (at-midnight start-date)
         start-year (dt/year start-date)
         end-year (dt/year end-date)
         public-holidays
         (->>
           holiday-list
           (filter #(and (>= (dt/year %) start-year) (<= (dt/year %) end-year)))
           (set))
         is-business-day?
         (fn [dt]
           (and
             (not (contains? public-holidays dt))
             (or
               (tp/weekday? dt)
               (when saturday-as-business-day
                 (tp/saturday? dt)))))
         number-of-business-days 0]

     (loop [date-time ref-date count number-of-business-days]
       (cond
         (dt/after? date-time end-date)
         count

         (>= count 11)
         count

         (and (same-day? date-time end-date) (is-business-day? date-time))
         (inc count)

         :else
         (recur
           (->
             direction-fns
             (get direction #'dt/plus)
             (apply [date-time (dt/days 1)]))
           (if
             (is-business-day? date-time)
             (inc count)
             count)))))))


(defn compare-local-dates [this that]
  #?(:cljs
     (dt/compare-local-dates this that)
     :clj
     (let [yo (.getYear this)
           yother (.getYear that)
           dayo (.getDayOfYear this)
           dayother (.getDayOfYear that)]
       (cond
         (not= yo yother) (- yo yother)
         (not= dayo dayother) (- dayo dayother)
         :else 0))))


(defn clamp-time [blocksize time ceil?]
  (let [blocksize-ms (* blocksize 60000)
        round-fn (if ceil? #(Math/ceil %) #(Math/floor %))
        time-millis (+ (dt/milli time) (* 1000 (+ (* (dt/minute time) 60) (dt/second time))))
        rounded-seconds
        (* (round-fn (/ time-millis (float blocksize-ms))) blocksize-ms)]
    (if ceil?
      (dt/plus time (dt/millis (- rounded-seconds time-millis)))
      (dt/minus time (dt/millis (- time-millis rounded-seconds))))))

(defn clamp-timerange [blocksize start-time end-time]
  [(clamp-time blocksize start-time false)
   (clamp-time blocksize end-time true)])

(defn from-default-time-zone [dt]
  ;; in clojure default time zone is UTC, so, keep as is
  #?(:clj
     (dt/to-time-zone dt dt/utc)
     :cljs
     (dt/to-utc-time-zone dt)))

(defn to-default-time-zone [dt]
  #?(:clj
     (dt/to-time-zone dt dt/utc)
     :cljs
     (dt/to-default-time-zone dt)))

(defn leadtime [dt-a dt-b in-fn]
  (cond
    (or (nil? dt-a) (nil? dt-b))
    0

    :else
    (try
      (if (dt/before? dt-a dt-b)
        (in-fn (dt/interval dt-a dt-b))
        (- (in-fn (dt/interval dt-b dt-a))))
      (catch #?(:clj Exception :cljs js/Error) e 0))))

(defn approx-month-day-string [date]
  (when date
    (let [day (dt/day date)]
      (str
        (cond
          (< day 10) (str "early " (format-date date "MMMM"))
          (< day 20) (str "mid " (format-date date "MMMM"))
          (<= day 25) (str "late " (format-date date "MMMM"))
          :else (str "early " (format-date (dt/plus date (dt/days 15)) "MMMM")))))))

(defn php-elapsed [unixtime]
  (when (number? unixtime)
    (let [seconds (- (php-timestamp (dt/now)) unixtime)]
      (if (> seconds 86400)
        (str (u/floor (/ seconds 60 60 24)) " days ago")
        (str (u/floor (/ seconds 60 60)) " hours ago")))))

(defn is-holiday? [date-at-midnight & [holidays]]
  (contains?
    (set (or holidays (:dates (public-holidays))))
    date-at-midnight))

(comment

  (def day-data
    {:monday (dt/date-time 2019 3 18)
     :tuesday (dt/date-time 2019 3 19)
     :wednesday (dt/date-time 2019 3 20)
     :thursday (dt/date-time 2019 3 21)
     :friday (dt/date-time 2019 3 22)
     :saturday (dt/date-time 2019 3 23)
     :sunday (dt/date-time 2019 3 24)
     :monday2 (dt/date-time 2019 3 25)
     :tuesday2 (dt/date-time 2019 3 26)
     :wednesday2 (dt/date-time 2019 3 27)
     :thursday2 (dt/date-time 2019 3 28)
     :friday2 (dt/date-time 2019 3 29)
     :saturday2 (dt/date-time 2019 3 30)
     :sunday2 (dt/date-time 2019 3 31)})

  (=
    (business-days (:monday day-data) 5)
    (:monday2 day-data))

  (=
    (business-days (:monday day-data) 5 {:saturday-as-business-day true})
    (:saturday day-data))

  (=
    (business-days (:tuesday day-data) 5)
    (:tuesday2 day-data))

  (=
    (business-days (:wednesday day-data) 5)
    (:wednesday2 day-data))

  (=
    (business-days (:friday day-data) 5)
    (:friday2 day-data))

  (=
    (business-days (:friday2 day-data) 5 {:direction :backward})
    (:friday day-data))
  (=
    (business-days (:friday2 day-data) 5 {:direction :backward :saturday-as-business-day true})
    (:saturday day-data))

  (business-days (dt/now) 3 {:direction :xxx}))